import React, {useEffect, useState} from 'react';
import {useParams, useSearchParams} from 'react-router-dom';
import axios from 'axios';
import { useNavigate } from "react-router-dom";

import Header from "../../components/layout/Header";
import PageTitle from "../../components/layout/PageTitle";
import Wrapper from "../../components/layout/Wrapper";

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faBook,
    faClock,
    faCode,
    faPerson,
    faStar,
    faBrain
} from '@fortawesome/free-solid-svg-icons';

import Footer from "../../components/layout/Footer";
import {Helmet} from "react-helmet-async";
import {COURSE_API_BASE, SITE_URL} from "../../utils/apiConfig";
import Breadcrumb from "../../components/layout/Breadcrumb";
import ResponsiveImage from "../../components/elements/ResponsiveImage";
import Button from "../../components/elements/Button";
import {useAuth} from "../../context/AuthProvider";
import Toast from "../../components/layout/Toast";


const CoursePage = () => {

    const {
        isAuthenticated,
    } = useAuth();

    const {course_id} = useParams();

    const [course, setCourse] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);


    const navigate = useNavigate();

    const [toast, setToast] = useState(null);

    const [searchParams] = useSearchParams();

    useEffect(() => {
        if (
            isAuthenticated &&
            searchParams.get("enroll") === "1"
        ) {
            handleEnroll();
        }
    }, [isAuthenticated]);

    const handleEnroll = async () => {
        if (!isAuthenticated) {
            navigate(`/fa/auth?redirect=/fa/course/${course_id}&enroll=1`);
            return;
        }

        try {
            await axios.post(`${COURSE_API_BASE}/enroll/${course_id}`, {},{
                withCredentials: true
            });
            navigate(`/fa/account/course/${course_id}/content`);
        } catch (error) {

        }
    };
    useEffect(() => {
        const fetchCourse = async () => {

            setLoading(true);
            setError(null);

            try {
                const response = await axios.get(`${COURSE_API_BASE}/${course_id}`);

                const courseData = response.data?.course;


                if (response.data?.success && courseData) {
                    setCourse(courseData);
                } else {
                    setError("دوره پیدا نشد");
                }
            } catch (error) {
            } finally {
                setLoading(false);
            }
        };

        if (course_id) {
            fetchCourse();
        }
    }, [course_id]);

    const getDifficulty = (difficulty) => {

        switch (difficulty) {

            case 0:
                return 'مبتدی';

            case 1:
                return 'متوسط';

            case 2:
                return 'حرفه‌ای';

            default:
                return '';

        }
    };


    if (loading) {

        return (
            <div className="min-h-screen flex flex-col">

                <Header/>

                <main className="flex-1 my-8">

                    <Wrapper>

                        <div className="flex justify-center items-center py-32">

                            <span className="text-lg text-gray-500">
                                در حال بارگذاری دوره...
                            </span>

                        </div>

                    </Wrapper>

                </main>

                <Footer/>

            </div>
        );

    }


    if (error || !course) {

        return (
            <div className="min-h-screen flex flex-col">

                <Header/>

                <main className="flex-1 my-8">

                    <Wrapper>

                        <div className="flex justify-center items-center py-32">

                            <span className="text-lg text-gray-500">
                                دوره مورد نظر پیدا نشد.
                            </span>

                        </div>

                    </Wrapper>

                </main>

                <Footer/>

            </div>
        );

    }


    const breadcrumbItems = [
        {
            link: '/fa/course',
            title: 'دوره‌ها'
        },
        {
            link: `/fa/course/${course.id}`,
            title: course.title
        }
    ];


    return (
        <>
            <Helmet>

                <title>
                    {course.title} | کدپرو
                </title>

                <link
                    rel="canonical"
                    href={`${SITE_URL}/course/${course.id}`}
                />

                <meta
                    name="description"
                    content={course.description || `دوره آموزش ${course.title} در کدپرو`}
                />

            </Helmet>


            <div className="min-h-screen flex flex-col">

                <Header/>


                <main className="flex-1 my-8">

                    <Breadcrumb
                        items={breadcrumbItems}
                    />


                    <Wrapper>

                        <PageTitle
                            title={course.title}
                        />


                        <div className="flex flex-1 w-full mt-2 gap-5">


                            {/* Main Content */}

                            <div className="w-full lg:w-1/2 flex flex-col gap-5">

                                {/* Course image */}

                                <ResponsiveImage
                                    className="rounded-md"
                                    src={course.image}
                                    alt={course.title}/>


                                {/* Difficulty */}

                                {getDifficulty(course.difficulty) && (

                                    <div className="flex items-center gap-2 text-gray-700">

                                        <FontAwesomeIcon
                                            icon={faBrain}
                                        />

                                        <span>
                                            سطح دوره:
                                        </span>

                                        <strong>
                                            {getDifficulty(course.difficulty)}
                                        </strong>

                                    </div>

                                )}


                                {/* Description */}

                                <h2 className="mt-3 mb-2 text-2xl font-bold">
                                    توضیحات
                                </h2>

                                <p className="text-lg text-gray-800 leading-9 whitespace-pre-line">
                                    {course.description}
                                </p>


                                {/* Syllabus */}

                                <h2 className="mt-8 mb-3 text-2xl font-bold">
                                    سرفصل‌ها
                                </h2>


                                {Array.isArray(course.syllabus) &&
                                course.syllabus.length > 0 ? (

                                    <ul className="flex flex-col text-lg w-full gap-3">

                                        {course.syllabus.map((item, index) => (

                                            <li
                                                key={index}
                                                className="border-b border-gray-200 pb-3"
                                            >
                                                {typeof item === 'string'
                                                    ? item
                                                    : item?.title || item?.name || ''}
                                            </li>

                                        ))}

                                    </ul>

                                ) : (

                                    <p className="text-gray-500">
                                        سرفصلی برای این دوره ثبت نشده است.
                                    </p>

                                )}

                            </div>


                            {/* Course Information */}

                            <div
                                className="
                                    w-full lg:w-1/3
                                    h-fit
                                    sticky
                                    top-32
                                    rounded-lg
                                    bg-gray-100
                                    mr-auto
                                    border-2
                                    border-gray-200
                                    flex-col
                                    p-2
                                "
                            >


                                {/* Users */}

                                <div
                                    className="
                                        w-full
                                        flex
                                        justify-between
                                        items-center
                                        p-5
                                        border-b-2
                                        border-gray-200
                                    "
                                >

                                    <span className="block font-bold text-lg">
                                        تعداد کاربران
                                    </span>

                                    <span>
                                        <span>
                                            {course.users ?? '-'}
                                        </span>

                                        <FontAwesomeIcon
                                            icon={faPerson}
                                            size="md"
                                            className="mr-2"
                                        />
                                    </span>

                                </div>


                                {/* Lessons */}

                                <div
                                    className="
                                        w-full
                                        flex
                                        justify-between
                                        items-center
                                        p-5
                                        border-b-2
                                        border-gray-200
                                    "
                                >

                                    <span className="block font-bold text-lg">
                                        تعداد درسنامه
                                    </span>

                                    <span>
                                        <span>
                                            {course.lessons ?? 0}
                                        </span>

                                        <FontAwesomeIcon
                                            icon={faBook}
                                            size="md"
                                            className="mr-2"
                                        />
                                    </span>

                                </div>


                                {/* Projects */}

                                <div
                                    className="
                                        w-full
                                        flex
                                        justify-between
                                        items-center
                                        p-5
                                        border-b-2
                                        border-gray-200
                                    "
                                >

                                    <span className="block font-bold text-lg">
                                        تعداد پروژه
                                    </span>

                                    <span>
                                        <span>
                                            {course.projects ?? 0}
                                        </span>

                                        <FontAwesomeIcon
                                            icon={faCode}
                                            size="md"
                                            className="mr-2"
                                        />
                                    </span>

                                </div>


                                {/* Category */}

                                <div
                                    className="
                                        w-full
                                        flex
                                        justify-between
                                        items-center
                                        p-5
                                        border-b-2
                                        border-gray-200
                                    "
                                >

                                    <span className="block font-bold text-lg">
                                        دسته‌بندی
                                    </span>

                                    <span>
                                        {course.category || '-'}
                                    </span>

                                </div>



                                <Button className="w-full m-2" onClick={handleEnroll}>
                                    {
                                        isAuthenticated ? (
                                            <span>برو به دوره</span>
                                        ) : (<span>ثبت‌نام در دوره</span>)
                                    }
                                </Button>

                            </div>

                        </div>

                        <Toast toast={toast} />
                        <div className="flex flex-col blog flex-1 w-full mt-10" id="course-text">
                            <h2>دوره جامع پایتون چیست؟</h2>

                            <p>
                                دوره جامع پایتون کدپرو یک مسیر آموزشی کامل برای یادگیری زبان برنامه‌نویسی پایتون از سطح کاملاً مقدماتی تا مباحث کاربردی‌تر برنامه‌نویسی است. این دوره برای افرادی طراحی شده است که ممکن است هیچ تجربه‌ای در برنامه‌نویسی نداشته باشند و می‌خواهند قدم‌به‌قدم با مفاهیم اصلی برنامه‌نویسی و زبان پایتون آشنا شوند.
                            </p>

                            <p>
                                پایتون یکی از محبوب‌ترین زبان‌های برنامه‌نویسی در جهان است و به دلیل خوانایی بالا، سینتکس نسبتاً ساده و کاربردهای متنوع، انتخاب مناسبی برای شروع یادگیری برنامه‌نویسی محسوب می‌شود. در این دوره تلاش می‌کنیم مفاهیم را فقط به صورت تئوری آموزش ندهیم؛ بلکه با مثال، تمرین و پروژه آن‌ها را به مهارت عملی تبدیل کنیم.
                            </p>

                            <p>
                                در طول دوره با مفاهیمی مانند متغیرها، انواع داده، عملگرها، لیست‌ها، شرط‌ها، حلقه‌ها و توابع آشنا می‌شوید و یاد می‌گیرید چگونه از این مفاهیم برای ساخت برنامه‌های واقعی استفاده کنید.
                            </p>


                            <h2>این دوره برای چه کسانی مناسب است؟</h2>

                            <p>
                                دوره جامع پایتون برای افرادی ساخته شده است که می‌خواهند برنامه‌نویسی را از پایه شروع کنند. برای شرکت در این دوره لازم نیست قبلاً زبان برنامه‌نویسی دیگری بلد باشید یا دانش تخصصی در زمینه کامپیوتر داشته باشید.
                            </p>

                            <h3>اگر کاملاً مبتدی هستید</h3>

                            <p>
                                اگر تاکنون حتی یک خط کد ننوشته‌اید، این دوره می‌تواند نقطه شروع شما باشد. مطالب از مفاهیم پایه آغاز می‌شوند و هر موضوع قبل از رفتن به مباحث بعدی با مثال و تمرین توضیح داده می‌شود. هدف این است که به جای حفظ کردن دستورات، منطق پشت کدنویسی را یاد بگیرید.
                            </p>

                            <h3>اگر قبلاً کمی برنامه‌نویسی کرده‌اید</h3>

                            <p>
                                اگر قبلاً تجربه محدودی در برنامه‌نویسی داشته‌اید، دوره می‌تواند به شما کمک کند مفاهیم پایه را منظم‌تر یاد بگیرید و نقاط ضعف خود را برطرف کنید. ساختار مرحله‌ای دوره باعث می‌شود بتوانید مباحث مختلف را به ترتیب منطقی مرور کنید.
                            </p>


                            <h2>چرا یادگیری پایتون؟</h2>

                            <p>
                                پایتون یکی از زبان‌هایی است که در حوزه‌های مختلف فناوری استفاده می‌شود. از توسعه نرم‌افزار و ساخت ابزارهای کاربردی گرفته تا تحلیل داده، هوش مصنوعی، اتوماسیون و توسعه وب، پایتون در پروژه‌های مختلف مورد استفاده قرار می‌گیرد.
                            </p>

                            <p>
                                یکی از مهم‌ترین ویژگی‌های پایتون، خوانایی کد است. سینتکس این زبان به شکلی طراحی شده که کدهای پایتون در بسیاری از مواقع نسبت به زبان‌های دیگر ساده‌تر خوانده و نوشته می‌شوند. همین ویژگی باعث شده است پایتون برای آموزش مفاهیم برنامه‌نویسی نیز گزینه مناسبی باشد.
                            </p>

                            <p>
                                البته ساده بودن سینتکس به معنی ساده بودن برنامه‌نویسی نیست. برای تبدیل شدن به یک برنامه‌نویس باید بتوانید مسئله را تحلیل کنید، آن را به بخش‌های کوچک‌تر تقسیم کنید و برای حل آن الگوریتم طراحی کنید. در این دوره علاوه بر دستورات پایتون، روی همین طرز فکر نیز تمرکز می‌کنیم.
                            </p>


                            <h2>در دوره جامع پایتون چه چیزهایی یاد می‌گیرید؟</h2>

                            <p>
                                مطالب دوره به چند بخش اصلی تقسیم شده‌اند تا یادگیری مرحله‌به‌مرحله باشد. در هر بخش ابتدا مفهوم جدید معرفی می‌شود و سپس با مثال‌ها و تمرین‌های مختلف آن را به کار می‌برید.
                            </p>

                            <h3>مقدمه و شروع برنامه‌نویسی با پایتون</h3>

                            <p>
                                در ابتدای دوره با مفهوم برنامه‌نویسی و زبان‌های برنامه‌نویسی آشنا می‌شوید و یاد می‌گیرید یک برنامه ساده پایتون چگونه اجرا می‌شود. در این بخش با ساختار کلی کد، دستورات ابتدایی و روش اجرای برنامه‌ها آشنا خواهید شد.
                            </p>

                            <p>
                                همچنین با محیط مورد نیاز برای نوشتن و اجرای کد آشنا می‌شوید و اولین برنامه‌های خود را می‌نویسید. هدف این بخش این است که بدون پیچیده کردن موضوع، اولین تجربه شما از نوشتن کد شکل بگیرد.
                            </p>

                            <h3>متغیرها و انواع داده</h3>

                            <p>
                                متغیر یکی از پایه‌ای‌ترین مفاهیم برنامه‌نویسی است. در این بخش یاد می‌گیرید چگونه اطلاعات را در برنامه ذخیره و از آن‌ها استفاده کنید.
                            </p>

                            <p>
                                با انواع داده پرکاربرد مانند اعداد صحیح، اعداد اعشاری، رشته‌ها و مقادیر بولی آشنا می‌شوید و تفاوت آن‌ها را یاد می‌گیرید. همچنین با مفاهیمی مانند مقداردهی، تغییر مقدار متغیر و استفاده از متغیرها در محاسبات و دستورات مختلف کار خواهید کرد.
                            </p>

                            <p>
                                در ادامه یاد می‌گیرید چگونه نوع داده یک مقدار را بررسی کنید و چرا شناخت نوع داده در هنگام نوشتن برنامه اهمیت دارد.
                            </p>

                            <h3>ورودی و خروجی</h3>

                            <p>
                                یک برنامه کاربردی معمولاً باید بتواند اطلاعاتی از کاربر دریافت کند و نتیجه را به او نمایش دهد. در این بخش با روش دریافت ورودی از کاربر و نمایش خروجی آشنا می‌شوید.
                            </p>

                            <p>
                                با استفاده از ورودی‌ها می‌توانید برنامه‌هایی بسازید که رفتار آن‌ها بر اساس اطلاعاتی که کاربر وارد می‌کند تغییر کند. این مفهوم پایه بسیاری از برنامه‌های تعاملی است.
                            </p>


                            <h3>عملگرها</h3>

                            <p>
                                عملگرها ابزارهایی هستند که برای انجام عملیات مختلف روی داده‌ها استفاده می‌شوند. در این بخش با عملگرهای حسابی، انتسابی، مقایسه‌ای و منطقی آشنا می‌شوید.
                            </p>

                            <p>
                                عملگرهای حسابی برای انجام محاسباتی مانند جمع، تفریق، ضرب و تقسیم استفاده می‌شوند. عملگرهای مقایسه‌ای به شما اجازه می‌دهند مقادیر مختلف را با یکدیگر مقایسه کنید و عملگرهای منطقی برای ترکیب یا بررسی چند شرط کاربرد دارند.
                            </p>

                            <h3>اولویت عملگرها</h3>

                            <p>
                                وقتی چندین عملگر در یک عبارت وجود داشته باشد، ترتیب اجرای آن‌ها اهمیت پیدا می‌کند. در این بخش با مفهوم اولویت عملگرها آشنا می‌شوید و یاد می‌گیرید چگونه با استفاده از پرانتز و ساختار صحیح عبارت‌ها، نتیجه مورد انتظار خود را به دست آورید.
                            </p>


                            <h3>رشته‌ها و کار با متن</h3>

                            <p>
                                رشته‌ها یکی از مهم‌ترین انواع داده در برنامه‌نویسی هستند. در این بخش با ساخت و استفاده از رشته‌ها و روش‌های مختلف کار با متن آشنا می‌شوید.
                            </p>

                            <p>
                                یاد می‌گیرید چگونه چند رشته را به یکدیگر متصل کنید، اطلاعات مختلف را در متن قرار دهید و با داده‌های متنی کار کنید. این مفاهیم در بسیاری از برنامه‌های واقعی، از فرم‌های ساده گرفته تا پردازش داده، کاربرد دارند.
                            </p>


                            <h3>لیست‌ها</h3>

                            <p>
                                در برنامه‌های واقعی معمولاً با یک مقدار منفرد کار نمی‌کنیم و لازم است مجموعه‌ای از اطلاعات را نگهداری کنیم. لیست‌ها یکی از ساختارهای داده مهم پایتون برای این کار هستند.
                            </p>

                            <p>
                                در این بخش یاد می‌گیرید چگونه لیست ایجاد کنید، به عناصر آن دسترسی داشته باشید و اطلاعات موجود در آن را تغییر دهید. همچنین با روش‌های مختلف کار با عناصر لیست آشنا می‌شوید.
                            </p>

                            <p>
                                یادگیری لیست‌ها پایه مهمی برای درک ساختارهای داده و نوشتن برنامه‌های پیچیده‌تر است.
                            </p>


                            <h2>کنترل جریان برنامه</h2>

                            <p>
                                یکی از تفاوت‌های اصلی بین یک برنامه ساده و یک برنامه کاربردی، توانایی تصمیم‌گیری و تکرار عملیات است. برنامه‌ها باید بتوانند بر اساس شرایط مختلف رفتار متفاوتی داشته باشند و بعضی عملیات را چندین بار انجام دهند.
                            </p>

                            <h3>شرط‌ها و دستور if</h3>

                            <p>
                                با استفاده از شرط‌ها می‌توانید تعیین کنید که یک بخش از برنامه تحت چه شرایطی اجرا شود. در این بخش با دستور <code>if</code> آشنا می‌شوید و یاد می‌گیرید چگونه بر اساس مقدار متغیرها یا نتیجه مقایسه‌ها تصمیم‌گیری کنید.
                            </p>

                            <h3>دستور elif</h3>

                            <p>
                                گاهی یک برنامه تنها دو حالت ندارد و باید چند حالت مختلف را بررسی کند. دستور <code>elif</code> به شما اجازه می‌دهد چند شرط را به صورت پشت سر هم بررسی کنید و بر اساس اولین شرط برقرار، بخش مناسب برنامه را اجرا کنید.
                            </p>

                            <h3>دستور else</h3>

                            <p>
                                در صورتی که هیچ‌کدام از شرط‌های قبلی برقرار نباشند، می‌توان از <code>else</code> استفاده کرد. ترکیب <code>if</code>، <code>elif</code> و <code>else</code> یکی از مهم‌ترین ابزارهای تصمیم‌گیری در برنامه‌های پایتون است.
                            </p>


                            <h2>حلقه‌ها در پایتون</h2>

                            <p>
                                گاهی لازم است یک عملیات چندین بار تکرار شود. برای مثال ممکن است بخواهید روی تمام عناصر یک لیست عملیات مشخصی انجام دهید. حلقه‌ها برای همین منظور استفاده می‌شوند.
                            </p>

                            <h3>حلقه for</h3>

                            <p>
                                در این بخش با حلقه <code>for</code> آشنا می‌شوید و یاد می‌گیرید چگونه روی مجموعه‌ای از داده‌ها حرکت کنید و برای هر عنصر یک عملیات مشخص انجام دهید.
                            </p>

                            <p>
                                حلقه‌های <code>for</code> یکی از پرکاربردترین بخش‌های پایتون هستند و در بسیاری از برنامه‌ها برای پردازش مجموعه‌ای از داده‌ها استفاده می‌شوند.
                            </p>

                            <h3>حلقه while</h3>

                            <p>
                                حلقه <code>while</code> زمانی کاربرد دارد که بخواهیم اجرای یک بخش از برنامه تا زمانی که یک شرط برقرار است ادامه پیدا کند. در این بخش با منطق حلقه‌های شرطی و نحوه کنترل تکرار آشنا می‌شوید.
                            </p>

                            <p>
                                درک صحیح حلقه‌ها به شما کمک می‌کند برنامه‌هایی بنویسید که بتوانند حجم زیادی از عملیات را بدون تکرار دستی کد انجام دهند.
                            </p>


                            <h2>توابع در پایتون</h2>

                            <p>
                                هرچه برنامه‌ها بزرگ‌تر می‌شوند، نوشتن تمام کدها در یک بخش باعث پیچیده شدن برنامه می‌شود. توابع به شما اجازه می‌دهند بخش‌هایی از منطق برنامه را در واحدهای مستقل قرار دهید و در قسمت‌های مختلف دوباره از آن‌ها استفاده کنید.
                            </p>

                            <p>
                                در بخش توابع یاد می‌گیرید چگونه یک تابع تعریف کنید، ورودی دریافت کنید و نتیجه برگردانید. همچنین با مفهوم پارامترها و نحوه استفاده از توابع در برنامه‌های مختلف آشنا می‌شوید.
                            </p>

                            <p>
                                یادگیری توابع یکی از مراحل مهم در مسیر تبدیل شدن از یک فرد مبتدی به برنامه‌نویسی است که می‌تواند کدهای مرتب‌تر و قابل استفاده مجدد بنویسد.
                            </p>


                            <h2>یادگیری با تمرین و پروژه</h2>

                            <p>
                                برنامه‌نویسی مهارتی نیست که فقط با خواندن مطالب آموزشی به دست بیاید. برای یادگیری واقعی باید کد بنویسید، خطا کنید، خطاها را بررسی کنید و دوباره راه‌حل خود را امتحان کنید.
                            </p>

                            <p>
                                به همین دلیل در دوره جامع پایتون کدپرو تلاش شده است یادگیری با تمرین همراه باشد. تمرین‌ها به شما کمک می‌کنند مفاهیمی را که یاد گرفته‌اید بلافاصله در کد استفاده کنید.
                            </p>

                            <p>
                                با پیشرفت در دوره، پروژه‌ها نیز به شما کمک می‌کنند چند مفهوم مختلف را در کنار یکدیگر قرار دهید و از آن‌ها برای حل یک مسئله استفاده کنید. این مرحله اهمیت زیادی دارد، زیرا در پروژه‌های واقعی معمولاً یک مفهوم به تنهایی کافی نیست و باید چندین مهارت را با یکدیگر ترکیب کنید.
                            </p>


                            <h2>بعد از یادگیری پایتون چه کارهایی می‌توانید انجام دهید؟</h2>

                            <p>
                                یادگیری مباحث پایه پایتون پایان مسیر نیست؛ بلکه نقطه شروع ورود به حوزه‌های مختلف برنامه‌نویسی است. پس از اینکه مفاهیم پایه را به خوبی یاد گرفتید، می‌توانید مسیر خود را بر اساس علاقه و هدف خود ادامه دهید.
                            </p>

                            <h3>توسعه وب</h3>

                            <p>
                                پایتون در توسعه وب نیز کاربرد دارد و فریم‌ورک‌هایی مانند Django و Flask امکان ساخت وب‌سایت‌ها و سرویس‌های مختلف را فراهم می‌کنند. اگر به ساخت وب‌سایت و API علاقه دارید، یادگیری پایتون می‌تواند پایه مناسبی برای ورود به این حوزه باشد.
                            </p>

                            <h3>هوش مصنوعی و یادگیری ماشین</h3>

                            <p>
                                پایتون یکی از زبان‌های بسیار پرکاربرد در حوزه هوش مصنوعی و یادگیری ماشین است. کتابخانه‌ها و ابزارهای متنوع این اکوسیستم باعث شده‌اند پایتون در پروژه‌های مرتبط با تحلیل داده، یادگیری ماشین و هوش مصنوعی مورد استفاده قرار بگیرد.
                            </p>

                            <h3>تحلیل داده</h3>

                            <p>
                                اگر به کار با داده‌ها علاقه دارید، می‌توانید پس از یادگیری پایتون به سراغ ابزارهای تحلیل داده بروید. در این مسیر می‌توانید یاد بگیرید چگونه داده‌ها را پردازش، تحلیل و به شکل قابل فهم نمایش دهید.
                            </p>

                            <h3>اتوماسیون</h3>

                            <p>
                                یکی دیگر از کاربردهای جذاب پایتون، خودکارسازی کارهای تکراری است. بسیاری از کارهایی که انجام آن‌ها به صورت دستی زمان‌بر است را می‌توان با برنامه‌نویسی خودکار کرد. این موضوع یکی از کاربردهای عملی و قابل لمس پایتون برای برنامه‌نویسان است.
                            </p>


                            <h2>روش پیشنهادی برای یادگیری بهتر</h2>

                            <p>
                                برای اینکه از دوره جامع پایتون بیشترین استفاده را ببرید، پیشنهاد می‌کنیم مطالب را با عجله پشت سر نگذارید. هدف اصلی نباید تمام کردن سریع دوره باشد؛ بلکه باید بتوانید مفاهیم را در کدهای خودتان استفاده کنید.
                            </p>

                            <p>
                                بعد از هر درس، مثال‌ها را خودتان دوباره بنویسید و سعی کنید تغییراتی در آن‌ها ایجاد کنید. اگر یک برنامه ساده مشاهده کردید، فقط به اجرای آن اکتفا نکنید؛ سعی کنید حدس بزنید اگر مقدار ورودی یا بخشی از کد را تغییر دهید چه اتفاقی خواهد افتاد.
                            </p>

                            <p>
                                همچنین هنگام مواجه شدن با خطا، سریعاً از کنار آن عبور نکنید. خطاها بخش طبیعی برنامه‌نویسی هستند و یادگیری نحوه خواندن و رفع آن‌ها یکی از مهارت‌های مهم یک برنامه‌نویس است.
                            </p>


                            <h2>مسیر یادگیری شما در دوره جامع پایتون</h2>

                            <p>
                                در این دوره مسیر یادگیری از مفاهیم ساده شروع می‌شود و به تدریج مفاهیم بیشتری به آن اضافه می‌شوند. ابتدا با اصول اولیه آشنا می‌شوید، سپس متغیرها و انواع داده را یاد می‌گیرید و بعد از آن با عملگرها، ساختارهای داده، شرط‌ها، حلقه‌ها و توابع کار می‌کنید.
                            </p>

                            <p>
                                این ترتیب باعث می‌شود هر مفهوم جدید روی دانشی که در مراحل قبلی به دست آورده‌اید ساخته شود. در نتیجه به جای مواجه شدن با مجموعه‌ای از دستورات پراکنده، یک تصویر منسجم از اصول برنامه‌نویسی پیدا می‌کنید.
                            </p>

                            <p>
                                در پایان این مسیر انتظار می‌رود بتوانید برنامه‌های ساده پایتون را خودتان طراحی و پیاده‌سازی کنید، مسئله را به بخش‌های کوچک‌تر تقسیم کنید و از مفاهیم پایه زبان برای رسیدن به یک راه‌حل استفاده کنید.
                            </p>


                            <h2>شروع یادگیری پایتون با کدپرو</h2>

                            <p>
                                اگر به دنبال شروع برنامه‌نویسی هستید، دوره جامع پایتون کدپرو می‌تواند مسیر شما را از اولین خط کد تا ساخت برنامه‌های کاربردی‌تر همراهی کند. مطالب دوره با هدف آموزش مرحله‌ای طراحی شده‌اند تا حتی اگر تجربه قبلی در برنامه‌نویسی ندارید، بتوانید از مفاهیم پایه شروع کنید و قدم‌به‌قدم پیش بروید.
                            </p>

                            <p>
                                یادگیری برنامه‌نویسی نیاز به تمرین و استمرار دارد. هرچه بیشتر کد بنویسید و مسائل بیشتری حل کنید، درک شما از مفاهیم نیز عمیق‌تر خواهد شد. بنابراین دوره را شروع کنید، تمرین‌ها را انجام دهید و سعی کنید آموخته‌های خود را در پروژه‌های مختلف به کار ببرید.
                            </p>

                            <p>
                                پایتون تنها یک زبان برنامه‌نویسی نیست؛ بلکه می‌تواند نقطه شروعی برای ورود به دنیای توسعه نرم‌افزار، وب، داده، هوش مصنوعی و بسیاری از حوزه‌های دیگر باشد. مسیر یادگیری خود را از پایه شروع کنید و با تمرین مداوم مهارت‌های خود را توسعه دهید.
                            </p>
                        </div>

                    </Wrapper>

                </main>


                <Footer/>

            </div>
        </>
    )
        ;
};


export default CoursePage;